import React from 'react';
import Page from '../../components/Page';
import Iconify from '../../components/Iconify';
import { TPayReport } from '../../sections/employee/settlement/TPayReport';
import { Card, CardContent, Tabs, Tab } from '@mui/material';
import BankStatements from '../../sections/employee/settlement/BankStatements';
import { DocumentRecord } from '../../sections/employee/settlement/DocumentRecord';
import { TemplateProductRecord } from '../../sections/employee/settlement/TemplateProductRecord';


const Settlement = () => {
  const [currentTab, setCurrentTab] = React.useState(0);

  return (
    <Page title="Rozrachunki" sx={{ height: '100%' }}>
      <Card sx={{ height: '100%' }}>
        <CardContent sx={{ height: '100%' }}>
          <Tabs value={currentTab} onChange={(e, value) => setCurrentTab(value)}>
            <Tab label="Dokumenty rozliczeniowe" icon={<Iconify icon="majesticons:analytics" width={20} height={20} />}/>
            <Tab label="wyciągi bankowe" icon={<Iconify icon="bx:money-withdraw" width={20} height={20} />}/>
            <Tab label="raporty tpay" icon={<Iconify icon="majesticons:analytics" width={20} height={20} />}/>
            <Tab label="Zdefiniowane pozycje faktur" icon={<Iconify icon="majesticons:analytics" width={20} height={20} />}/>
          </Tabs>
          {currentTab === 0
            ? < DocumentRecord/>
            : currentTab === 1
              ? < BankStatements/>
              : currentTab === 2
                ? <TPayReport />
                : currentTab === 3
                  ? <TemplateProductRecord />
                  : null}
        </CardContent>
      </Card>
    </Page>
  );
};


export default Settlement;
